var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSliderBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.33333 0C1.9401 0 0 1.98985 0 4.44444V15.5556C0 18.0102 1.9401 20 4.33333 20H8.95897L12.297 23.3038C12.6866 23.6894 13.3142 23.6894 13.7039 23.3038L17.0419 20H21.6667C24.0599 20 26 18.0102 26 15.5556V4.44444C26 1.98985 24.0599 0 21.6667 0H4.33333Z",
    fill: "#FAA53D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderBadge);
export default __webpack_public_path__ + "static/media/slider_badge.d2bd611a64a5041660db289c26138e5b.svg";
export { ForwardRef as ReactComponent };